// @flow strict-local

import { RootAction } from "../types";
import { Message } from "./types";

export interface State {
  messages: Message[];
}

function blankState(): State {
  return {
    messages: []
  };
}

export default function reducer(state: State | undefined, action: RootAction): State {
  if (!state) {
    return reducer(blankState(), action);
  }

  switch (action.type) {
    case "flash/add":
      return { messages: [...state.messages, action.message] };

    case "flash/expire":
      return { messages: state.messages.filter(({ id }) => id !== action.id) };

    default:
      return state;
  }
}
